






























































































































































































import Component, {mixins} from 'vue-class-component';
import {HomeIcon, UserIcon, KeyIcon} from 'vue-feather-icons';
import {namespace} from 'vuex-class';

const Auth = namespace('Auth');

import {BizSirenEncodeResponse, BizSirenResultDto} from '@/services/LoginModels';
import {AxiosResponse} from 'axios';
import {MemberInfo, PMSResLogin, SexType, User, UserIdFind, YesOrNo} from '@/models';
import {loginService} from '@/services/login.service';
import GeneralUtil from '@/util/GeneralUtil';
import {Vue, Watch} from 'vue-property-decorator';

declare global {
  interface Window {
    recvSirenPhoneResult: any;
  }
}
interface YourComponentType extends Vue {
  validate(): any;
}
@Component({
  components: {
    HomeIcon,
    UserIcon,
    KeyIcon,
  },
})
export default class FindPW extends mixins(GeneralUtil) {
  @Auth.Action
  private windowRef: any = null;
  private host = window.location.protocol + '//' + window.location.host;
  userIdFindDto: UserIdFind = {
    guestName: '',
    hpNo: '',
  };
  private reqInfo = '';
  private step = 1;
  private userId = '';
  private retInfo = '';
  private phoneVerified = false;
  private newPassword = '';
  private passwordRepeat = '';

  $refs!: {
    observer2: YourComponentType;
  };

  @Watch('userId', {immediate: true, deep: true})
  public userIdChanged(newValue: string, oldValue: string) {
    if (newValue !== oldValue) {
      this.userId = newValue.trim().toLowerCase();
    }
  }
  mounted(): void {
    // eslint-disable-next-line
    window.recvSirenPhoneResult = this.recvSirenPhoneResult;
    this.$store.dispatch('Display/changeName', {name: '비밀번호찾기'});
  }

  goLoginPage(): void {
    this.$router.push('/p/login');
  }

  goFindPWPage(): void {
    this.$bvModal.msgBoxOk('작업중입니다', {
      title: '비밀번호 찾기페이지 작업중',
      okVariant: 'success',
      centered: true,
    });
  }

  showAuthPage(): void {
    if (this.userId == '') {
      this.$bvModal.msgBoxOk('아이디를 입력 해주세요', {
        title: '아이디 입력필요',
        okVariant: 'success',
        centered: true,
      });
      return;
    }
    this.step = 2;
  }

  openPhoneAuthPopup(): void {
    console.log('auth attempt');
    //console.log(this.authPhoneDto);

    //핸드폰 본인인증 창열
    const retUrl = this.host + '/noHeader/p/bizSirenCallBackPhone';
    loginService.getBizSirenEncode(retUrl).then(response => {
      if (response.status == 200) {
        const responseData = response.data as BizSirenEncodeResponse;
        this.reqInfo = responseData.reqInfo;
        this.windowRef = window.open(
          '',
          '',
          'width=430, height=560, resizable=1, scrollbars=no, status=0, titlebar=0, toolbar=0, left=300, top=200',
        );
        const popupDocument = this.windowRef.document;
        const frm = popupDocument.createElement('form');
        frm.setAttribute('id', 'auth-form');
        frm.setAttribute('action', 'https://pcc.siren24.com/pcc_V3/jsp/pcc_V3_j10_v4.jsp');
        frm.setAttribute('method', 'post');
        frm.setAttribute('target', '_self');

        const element1 = popupDocument.createElement('input');
        element1.type = 'hidden';
        element1.value = responseData.cryptoTokenId;
        element1.name = 'crypto_token_id';
        frm.appendChild(element1);

        const element2 = popupDocument.createElement('input');
        element2.type = 'hidden';
        element2.value = responseData.integrityValue;
        element2.name = 'integrity_value';
        frm.appendChild(element2);

        const element3 = popupDocument.createElement('input');
        element3.type = 'hidden';
        element3.value = responseData.reqInfo;
        element3.name = 'reqInfo';
        frm.appendChild(element3);

        const element4 = popupDocument.createElement('input');
        element4.type = 'hidden';
        element4.value = responseData.verSion;
        element4.name = 'verSion';
        frm.appendChild(element4);

        popupDocument.body.appendChild(frm);
        //this.windowRef.document.body.appendChild(this.$el);
        //copyStyles(window.document, this.windowRef.document);
        //this.windowRef.addEventListener('beforeunload', this.closePopup);
        frm.submit();
      } else {
        //http response 오류 처리
      }
    });
  }

  recvSirenPhoneResult(type: string, result: BizSirenResultDto, retInfo: string): void {
    console.log(result);
    this.userIdFindDto.guestName = result.name;
    this.userIdFindDto.hpNo = result.cellNo;
    this.retInfo = retInfo;
    this.phoneVerified = true;

    loginService
      .userIdFindMissing(this.userIdFindDto)
      .then(response => {
        if (response.status == 200) {
          const responseData = response.data;
          console.log(responseData);
          if (responseData.resultCode == '0000') {
            this.step = 3;
          } else {
            this.$bvModal.msgBoxOk('가입된 아이디가 존재하지 않습니다.', {
              title: '아이디 찾기',
              okVariant: 'danger',
              centered: true,
            });
          }
        } else {
          //http response 오류 처리
        }
      })
      .catch(error => {
        console.log(error.response);
        //window.opener.recvKakaoResult(error.response);
        this.$bvModal.msgBoxOk(error.response.data, {
          title: '아이디 검색실패',
          centered: true,
        });
      });
  }

  async userPwChange(): Promise<void> {
    const isValid = await this.$refs.observer2.validate();
    if (!isValid) {
      await this.$bvModal.msgBoxOk('비밀번호를 규칙에 맞게 입력해주세요.', {
        title: '비밀번호 규칙 확인',
        okVariant: 'success',
        centered: true,
      });
      return;
    }

    if (!this.phoneVerified) {
      this.$bvModal.msgBoxOk('본인인증을 해주세요', {
        title: '본인인증 필요',
        okVariant: 'success',
        centered: true,
      });
      this.step = 2;
      return;
    }
    if (this.newPassword === '' || this.newPassword !== this.passwordRepeat) {
      this.$bvModal.msgBoxOk('비밀번호가 정확히 입력해주세요', {
        title: '비밀번호 확인',
        okVariant: 'success',
        centered: true,
      });
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;

    this.$bvModal
      .msgBoxConfirm('비밀번호를 변경하시겠습니까?', {
        title: '비밀번호변경',
        okVariant: 'success',
        centered: true,
      })
      .then(value => {
        loginService
          .userPwChangeNologin(this.userId, this.retInfo, this.newPassword)
          .then(async response => {
            if (response.status == 200) {
              const responseData = response.data;
              if (responseData.resultCode == '0000') {
                await this.$bvModal.msgBoxOk(
                  self.htmlToVNode('변경이 완료되었습니다.<br> 변경된 비밀번호로 로그인 부탁드립니다.'),
                  {
                    title: '패스워드변경성공',
                    okVariant: 'success',
                    centered: true,
                  },
                );
                this.$router.push('/');
              } else {
                this.$bvModal.msgBoxOk('패스워드변경실패', {
                  title: '오류발생',
                  okVariant: 'danger',
                  centered: true,
                });
              }
            } else {
              //http response 오류 처리
            }
          })
          .catch(error => {
            console.log(error.response);
            const message = error.response.data.message;
            //window.opener.recvKakaoResult(error.response);
            this.$bvModal.msgBoxOk(message, {
              title: '비밀번호 확인 실패',
              centered: true,
            });
          });
      });
  }
  removeEventSpaces(e: any): void {
    e.preventDefault();
    const left = e.target.value.substring(0, e.target.selectionStart);
    const right = e.target.value.substring(e.target.selectionEnd, e.target.value.length);
    const pasted = (e.dataTransfer || e.clipboardData).getData('text').replace(/ /g, '');
    e.target.value = left + pasted + right;
  }
}
